import { ActivePhonesData } from "@sms/shared/active-phones/active-phones.interface";
import React, { useCallback, useState } from "react";
import { InputMask } from "@react-input/mask";
import { Dispatch } from "redux";
import { useDispatch, useSelector } from "react-redux";
import { ChatCreateData } from "@sms/shared/chat/chat.interface";

import DefaultModal from "../default-modal/default-modal.component";
import stylesForm from "../../assets/styles/form.module.scss";

import { NewChatServiceDataState } from "./new-chat-services.types";

import { ApplicationStore } from "~/app/application.store";
import chatActions from "~/app/chat/chat.actions";
import { setNewChatServiceModalIsOpen } from "~/app/modals/modals.actions";

const NewChatServiceModalComponent: React.FC = () => {
  const dispatch: Dispatch<any> = useDispatch();

  const newChatServiceModalIsOpen: boolean = useSelector(
    (store: ApplicationStore) => store.modals.newChatServiceModalIsOpen
  );
  const activePhones: ActivePhonesData[] = useSelector((store: ApplicationStore) => store.activePhones.activePhones);

  const [chatServiceData, setChatServiceData]: [
    NewChatServiceDataState,
    React.Dispatch<React.SetStateAction<NewChatServiceDataState>>
  ] = useState<NewChatServiceDataState>({
    name: "",
    opponentPhone: "",
    activePhone: null,
    type: "service"
  });

  const handleSetNewChatServiceModalIsOpen: (isOpen: boolean) => void = useCallback(
    (isOpen: boolean) => {
      dispatch(setNewChatServiceModalIsOpen(isOpen));
    },
    [dispatch]
  );

  const createChat: (createChatData: ChatCreateData) => void = useCallback(
    (createChatData: ChatCreateData) => {
      dispatch(chatActions.createChat(createChatData));
    },
    [dispatch]
  );

  const handleChange: (target: { name: string; value: string }) => void = (target: {
    name: string;
    value: string;
  }): void => {
    setChatServiceData({
      ...chatServiceData,
      [target.name]: target.name === "opponentPhone" ? target.value.replace(/[\s()_-]/g, "") : target.value
    });
  };

  const handleChangeActivePhone: (target: { name: string; value: string }) => void = (target: {
    name: string;
    value: string;
  }): void => {
    const activePhone: ActivePhonesData | undefined = activePhones.find(
      activePhone => target.value === activePhone.activePhoneId
    );

    setChatServiceData({
      ...chatServiceData,
      activePhone: activePhone ? activePhone : null
    });
  };

  const handleCreateChat: () => void = (): void => {
    if (chatServiceData.activePhone && chatServiceData.opponentPhone.length >= 12) {
      createChat({
        name: chatServiceData.name,
        oponnentPhone: chatServiceData.opponentPhone,
        activePhone: chatServiceData.activePhone,
        type: chatServiceData.type
      });
    }
  };

  return (
    <DefaultModal
      title="New chat Twilio"
      modalState={newChatServiceModalIsOpen}
      setModalState={handleSetNewChatServiceModalIsOpen}
      action={handleCreateChat}
    >
      <div className={stylesForm.inputGroup}>
        <input name="name" onChange={(e): void => handleChange(e.target)} placeholder="Name" />
      </div>
      <div className={stylesForm.inputGroup}>
        <select
          name="activePhone"
          onChange={(e): void => handleChangeActivePhone(e.target)}
          value={chatServiceData.activePhone ? chatServiceData.activePhone.activePhoneId : ""}
        >
          <option>Select phone from</option>
          {activePhones.map(activePhone => {
            return (
              <option value={activePhone.activePhoneId} key={activePhone.activePhoneId}>
                {activePhone.phone}
              </option>
            );
          })}
        </select>
      </div>
      <div className={stylesForm.inputGroup}>
        <InputMask
          mask={"+__ __________"}
          replacement={{ _: /\d/ }}
          name="opponentPhone"
          onChange={(e: React.ChangeEvent<HTMLInputElement>): void => handleChange(e.target)}
          placeholder="Opponent phone"
        ></InputMask>
      </div>
    </DefaultModal>
  );
};

export default NewChatServiceModalComponent;
